import React, {useState, useEffect, useRef} from 'react';
import { 
    Flex, Box
} from '@chakra-ui/react';
import { useLocation, useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import LeftPanel from './Panel/LeftPanel';
import AlphaPicks from './AlphaPicks/AlphaPicks';
import AnalysicTickers from './Trackings/AnalysicTickers';
import StrategyTrading from './Dashboard/StrategyTrading';
import ProfitAndLoss from './Dashboard/ProfitAndLoss';
import Wallet from './Wallet/Wallet';
import Order from './Order/Order';
import Referral from './Referral/Referral';
import MyAccount from './Settings/MyAccount';
import Accounts from './Settings/Accounts';
import WalletTrackings from './Settings/WalletTrackings';
import SystemConfigs from './Settings/SystemConfigs';
import ListAutoTradeTransaction from './TradingView/ListAutoTradeTransaction';
import TradingViewConfig from './TradingView/Config';
import _404Page from "../components/404Page";
import { TRADINGVIEW_CONFIGS_SUB_PATH, TRADINGVIEW_TRANSACTIONS_SUB_PATH } from "../constants2";

function Main({ }) {
    const locations = useLocation();
    const navigate = useNavigate();
    const [ cookies, setCookie, removeCookie ] = useCookies(["loginCookie"]);
    if(
        cookies.loginCookie?.isAdministrator === false && 
        (
            locations.pathname === "/accounts" || locations.pathname === "/wallet-trackings" || 
            locations.pathname === "/system-configs" || locations.pathname === "/my-account"
        )
    ) {
        return <_404Page />
    }

    return (
        <Flex>
            <LeftPanel />
            {/* { locations.pathname === "/" && <AnalysicTickers /> }
            { locations.pathname === "/analysic-tickers" && <AlphaPicks /> }
            { locations.pathname === "/strategy-trading" && <StrategyTrading /> }
            { locations.pathname === "/profit-n-loss" && <ProfitAndLoss /> }
            { locations.pathname === "/wallet" && <Wallet /> }
            { locations.pathname === "/order" && <Order /> }
            { locations.pathname === "/referral" && <Referral /> }
            { locations.pathname === "/my-account" && <MyAccount /> }
            { locations.pathname === "/accounts" && <Accounts /> }
            { locations.pathname === "/wallet-trackings" && <WalletTrackings /> }
            { locations.pathname === "/system-configs" && <SystemConfigs /> } */}
            { locations.pathname === "/" && <ListAutoTradeTransaction /> }
            { locations.pathname === TRADINGVIEW_TRANSACTIONS_SUB_PATH && <ListAutoTradeTransaction /> }
            { locations.pathname === TRADINGVIEW_CONFIGS_SUB_PATH && <TradingViewConfig /> }
        </Flex>
    )
}

export default Main;